import { LogIn, LogOut, User as UserIcon, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";

export default function UserMenu() {
  const { t } = useI18n();
  const { user, favorites, login, logout } = useAuth();

  if (!user) {
    return (
      <Button
        onClick={login}
        size="sm"
        className="bg-emerald-500 hover:bg-emerald-600 text-black font-bold rounded-sm gap-2"
        data-testid="login-button"
      >
        <LogIn className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">{t("login_google")}</span>
      </Button>
    );
  }

  const initials = (user.name || user.email || "?").slice(0, 1).toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="user-menu-trigger"
          className="flex items-center gap-2 px-2 py-1 rounded-sm border border-zinc-700 hover:bg-zinc-900 transition-colors"
        >
          {user.picture ? (
            <img src={user.picture} alt="" className="w-6 h-6 rounded-sm object-cover" />
          ) : (
            <div className="w-6 h-6 rounded-sm bg-emerald-500/20 border border-emerald-500/40 flex items-center justify-center text-emerald-400 text-[11px] font-bold">
              {initials}
            </div>
          )}
          <span className="text-xs text-zinc-300 hidden md:inline max-w-[120px] truncate">
            {user.name || user.email}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#121212] border-zinc-800 min-w-[220px]">
        <div className="px-3 py-2 text-[11px] text-zinc-500 border-b border-zinc-800">
          <div className="flex items-center gap-1.5">
            <UserIcon className="h-3 w-3" />
            {user.email}
          </div>
        </div>
        <div className="px-3 py-2 text-[11px] text-zinc-400 flex items-center gap-2">
          <Star className="h-3 w-3 text-amber-400" />
          <span>{favorites.size} {t("favorites_count")}</span>
        </div>
        <DropdownMenuSeparator className="bg-zinc-800" />
        <DropdownMenuItem
          onClick={logout}
          data-testid="logout-button"
          className="cursor-pointer text-red-400 focus:bg-zinc-800 focus:text-red-300 gap-2"
        >
          <LogOut className="h-3.5 w-3.5" />
          {t("logout")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
